import React from 'react';

export const NoneIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="210" height="200" viewBox="0 0 210 200" fill="#A1ACB3" {...props}>
    <path
      d="M46.7756 158.121C48.9079 160.253 52.5319 160.431 54.7414 158.221L163.527 49.4357C165.736 47.2261 165.544 43.6166 163.412 41.4843C161.265 39.337 157.688 39.1782 155.479 41.3877L46.6934 150.173C44.484 152.383 44.6283 155.973 46.7756 158.121ZM147.482 142.116C170.648 118.95 170.655 80.5717 147.482 57.3989C124.275 34.1923 85.8966 34.2673 62.7314 57.4325C39.5245 80.6394 39.5508 118.917 62.7575 142.124C85.9303 165.296 124.275 165.323 147.482 142.116ZM139.138 133.772C120.262 152.648 89.9843 152.648 71.1089 133.772C52.2333 114.897 52.1923 84.6597 71.0754 65.7766C89.9173 46.9347 120.262 46.8674 139.138 65.743C158.013 84.6184 157.98 114.93 139.138 133.772Z"
    />
  </svg>
);
